import { tracker } from '../track';
export const trackSelectContent = (element, contentType, { contentId, info, themeHash, } = {}) => {
    const selectContent = {
        element: element,
        content_type: contentType,
        content_id: null,
        info: null,
        theme_hash: themeHash || null,
    };
    if (contentId) {
        selectContent.content_id = contentId;
    }
    if (info) {
        selectContent.info = info;
    }
    tracker.track('GA4-select_content', {
        event_name: 'select_content',
        select_content: selectContent,
    });
};
